// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue2-dropzone/dist/vue2Dropzone.min.css
// module id = 9BHd
// module chunks = 1